import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import { RootState } from '../store';

export interface MosaicState {
    isDragging: boolean;
    isResizing: boolean;
}

const initialState: MosaicState = {
    isDragging: false,
    isResizing: false
};

export const mosaicSlice = createSlice({
    name: 'mosaic',
    initialState,
    reducers: {
        setIsResizing: (state, action: PayloadAction<boolean>) => {
            state.isResizing = action.payload;
        },
        setIsDragging: (state, action: PayloadAction<boolean>) => {
            state.isDragging = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => initialState);
    }
});

export const { setIsDragging, setIsResizing } = mosaicSlice.actions;
export const selectMosaic = (state: RootState) => state.mosaic;

export default mosaicSlice.reducer;
